import { Routes } from '@angular/router';
import { PermissionGuard } from '../security/permission.guard';
import { EnterpriseSubscriptionGuard } from '../security/enterprise-subscription.guard';
import { TransportReleaseListComponent } from './release-list/transport-release-list.component';
import { TransportReleaseBulkUploadComponent } from './release-bulk-upload/transport-release-bulk-upload.component';
import { TransportReleaseFormComponent } from './release-form/transport-release-form.component';
import { TransportReleaseAddToShipmentComponent } from './add-to-shipment/transport-release-add-to-shipment.component';
import { TransportReleaseViewComponent } from './release-view/transport-release-view.component';
import { TransportPlanCreateComponent } from './plan-create/transport-plan-create.component';
import { TransportPlanListComponent } from './plan-list/transport-plan-list.component';
import { TransportPlanViewComponent } from './plan-view/transport-plan-view.component';
import { OrderReleasePublicTrackingComponent } from './public-tracking/order-release-public-tracking.component';
import { TransportCrossDockOrchestrationListComponent } from './orchestration-list/transport-cross-dock-orchestration-list.component';
import { TransportCrossDockOrchestrationViewComponent } from './orchestration-view/transport-cross-dock-orchestration-view.component';
import { app_permissions } from '../security/app-permissions';
import { LocationZoneSetupComponent } from './location-zones/location-zone-setup.component';
import { BulkPlanningWorkbenchComponent } from './bulk-planning/bulk-planning-workbench.component';
import { BulkRunDirectoryComponent } from './bulk-planning/bulk-run-directory.component';

export const transportPlanningRoutes: Routes = [
  {
    path: 'setup/location-zones',
    component: LocationZoneSetupComponent,
    canActivate: [PermissionGuard],
    data: { permission: app_permissions.warehousing.setup.view }
  },
  {
    path: 'track',
    component: OrderReleasePublicTrackingComponent
  },
  {
    path: 'track/:trackingNumber',
    component: OrderReleasePublicTrackingComponent
  },
  {
    path: 'transport-planning',
    canActivateChild: [EnterpriseSubscriptionGuard],
    data: { enterpriseModules: ['SHIPMENTS', 'FLEET'], enterpriseFeatureLabel: 'Transport Planning' },
    children: [
      {
        path: '',
        redirectTo: 'releases',
        pathMatch: 'full'
      },
      {
        path: 'releases',
        component: TransportReleaseListComponent,
        canActivate: [PermissionGuard],
        data: { permission: app_permissions.transport_planning.releases.view }
      },
      {
        path: 'releases/new',
        component: TransportReleaseFormComponent,
        canActivate: [PermissionGuard],
        data: { permission: app_permissions.transport_planning.releases.create }
      },
      {
        path: 'releases/bulk-upload',
        component: TransportReleaseBulkUploadComponent,
        canActivate: [PermissionGuard],
        data: { permission: app_permissions.transport_planning.releases.create }
      },
      {
        path: 'releases/add-to-shipment',
        component: TransportReleaseAddToShipmentComponent,
        canActivate: [PermissionGuard],
        data: { permission: app_permissions.transport_planning.releases.create }
      },
      {
        path: 'releases/:releaseId',
        component: TransportReleaseViewComponent,
        canActivate: [PermissionGuard],
        data: { permission: app_permissions.transport_planning.releases.view }
      },
      {
        path: 'orchestrations',
        component: TransportCrossDockOrchestrationListComponent,
        canActivate: [PermissionGuard],
        data: { permission: app_permissions.transport_planning.releases.view }
      },
      {
        path: 'orchestrations/:crossDockOrchestrationId',
        component: TransportCrossDockOrchestrationViewComponent,
        canActivate: [PermissionGuard],
        data: { permission: app_permissions.transport_planning.releases.view }
      },
      {
        path: 'plans',
        component: TransportPlanListComponent,
        canActivate: [PermissionGuard],
        data: { permission: app_permissions.transport_planning.plans.view }
      },
      {
        path: 'bulk-planning',
        component: BulkRunDirectoryComponent,
        canActivate: [PermissionGuard],
        data: { permission: app_permissions.transport_planning.plans.view }
      },
      {
        path: 'bulk-planning/new',
        component: BulkPlanningWorkbenchComponent,
        canActivate: [PermissionGuard],
        data: { permission: app_permissions.transport_planning.plans.create }
      },
      {
        path: 'bulk-planning/:runId',
        component: BulkPlanningWorkbenchComponent,
        canActivate: [PermissionGuard],
        data: { permission: app_permissions.transport_planning.plans.view }
      },
      {
        path: 'plans/create',
        component: TransportPlanCreateComponent,
        canActivate: [PermissionGuard],
        data: { permission: app_permissions.transport_planning.plans.create }
      },
      {
        path: 'plans/:planId',
        component: TransportPlanViewComponent,
        canActivate: [PermissionGuard],
        data: { permission: app_permissions.transport_planning.plans.view }
      }
    ]
  }
];
